"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionListType = exports.FormGridType = void 0;
var FormGridType;
(function (FormGridType) {
    FormGridType["Vertical"] = "Vertical";
    FormGridType["Horizontal"] = "Horizontal";
    FormGridType["Grid"] = "Grid";
})(FormGridType = exports.FormGridType || (exports.FormGridType = {}));
var OptionListType;
(function (OptionListType) {
    OptionListType["List"] = "List";
    OptionListType["KeyPair"] = "KeyPair";
    OptionListType["FreeForm"] = "FreeForm";
})(OptionListType = exports.OptionListType || (exports.OptionListType = {}));
//# sourceMappingURL=form-element.js.map